import { render, staticRenderFns } from "./SampleGroupingIndex.vue?vue&type=template&id=686170b9&"
import script from "./SampleGroupingIndex.vue?vue&type=script&lang=js&"
export * from "./SampleGroupingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports